export default {
  context: process.env.NODE_ENV !== 'development' ? `${process.env.VUE_APP_BASEURL}/ui` : `${process.env.VUE_APP_BASEURL}/ui`,
  // baseUrl: '/mock',
  baseUrl: process.env.NODE_ENV !== 'development' ? process.env.VUE_APP_BASEURL : '/dev',
  // baseUrl: '/wanghongkai',
  uploadSrc: '/front/attachment/upload/',
  uploadZip: '/front/attachment/uploadzip/',
  logoutSrc: `${process.env.VUE_APP_BASEURL}/logoff`,
  exportConfigSrc: `${process.env.VUE_APP_BASEURL}/front/common/exportConfigZip`,
  chromeVersion: 72,
  Firefox: 60
}
